import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { CustomFormFieldSubmission } from '@core/objects/form';
import * as Objects from '@core/objects';
import { UrlService } from '@core/services/url/url.service';
import { FileDownloadService } from '@core/services/download/file-download.service';
import { FileSignatureManagerService } from '@core/services/files/file-signature-manager.service';

@Component({
    selector: 'form-field-view-artwork-link-selector-v1',
    templateUrl: './view-artwork-link-selector-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewArtworkLinkSelectorV1FieldComponent implements OnInit {
    @Input() fieldSubmission: CustomFormFieldSubmission;


    constructor(private urlSrv: UrlService, private fileDownloadSrv: FileDownloadService, private signatureManager: FileSignatureManagerService) {}

    ngOnInit(): void {
        
    }

    /**
     * Download file with signature validation
     * 
     * @param file the file inside artwork result or selected.
     * If file has signature (access property), use new signed download method.
     * Otherwise fall back to legacy download method.
     */
    onFileClick(file: Objects.File) {
        // Cast to AmsFile if it has access property for signature-based download
        const amsFile = file as unknown as Objects.AmsFile;
        
        // Use new signed file download if file has signature (access property)
        if (amsFile && amsFile.access) {
            // Check if signature is expired
            if (this.signatureManager.isSignatureExpired(amsFile)) {
                // Signature expired - in this search context, files are fresh from API
                // So this shouldn't happen often, but handle gracefully by falling back
                window.location.href = this.urlSrv.build('/files/'+file.id);
            } else {
                // Signature is valid, download with secure URL
                this.fileDownloadSrv.downloadVersionAsset(amsFile);
            }
        } else {
            // Fall back to legacy download method for files without signature
            window.location.href = this.urlSrv.build('/files/'+file.id);
        }
    }

}
